module.exports = function() {
  return new Worker(__webpack_public_path__ + "e73ded1fd1320cd92c45.worker.js");
};